// Ô chọn "Tài khoản thử": gợi ý theo tên/email/userId, tag hiện "Tên · #id"; vẫn dán được nhiều id.
import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Input, Select, Space, message } from "antd";
import xuProgramApi from "../../../api/xuProgramApi";
import { platformLabel, ROLE_LABELS } from "./xu-format-helpers";

/** "Tên · #id · iOS · admin" */
export function userLabel(u) {
    const parts = [u.name || "(chưa đặt tên)", `#${u.userId}`];
    if (platformLabel(u.platform)) parts.push(platformLabel(u.platform));
    if (ROLE_LABELS[u.role]) parts.push(ROLE_LABELS[u.role]);
    return parts.join(" · ");
}

export default function XuBetaUserSelect({ ids, initialUsers, onChange }) {
    const [known, setKnown] = useState({}); // userId → thẻ user (để tag có tên)
    const [options, setOptions] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [paste, setPaste] = useState("");
    const timer = useRef(null);

    const remember = (users) => setKnown((prev) => ({ ...prev, ...Object.fromEntries(users.map((u) => [u.userId, u])) }));

    useEffect(() => {
        remember(initialUsers || []);
    }, [initialUsers]);

    const search = (q) => {
        clearTimeout(timer.current);
        timer.current = setTimeout(async () => {
            setFetching(true);
            try {
                const { data } = await xuProgramApi.suggestUsers(q || "");
                setOptions(data.data);
                remember(data.data);
            } catch {
                message.error("Không tải được gợi ý tài khoản");
            } finally {
                setFetching(false);
            }
        }, 300);
    };
    useEffect(() => () => clearTimeout(timer.current), []);

    const addPasted = async () => {
        const pasted = paste.split(/[\s,;]+/).map(Number).filter((n) => Number.isInteger(n) && n > 0);
        if (!pasted.length) return message.warning("Chưa có userId hợp lệ");
        const found = await Promise.all(pasted.map((id) => xuProgramApi.suggestUsers(String(id)).then((r) => r.data.data[0]).catch(() => null)));
        remember(found.filter(Boolean));
        onChange([...new Set([...ids, ...pasted])]);
        setPaste("");
    };

    const value = useMemo(() => ids.map((id) => ({ value: id, label: known[id] ? userLabel(known[id]) : `#${id}` })), [ids, known]);
    const merged = useMemo(() => {
        const seen = new Set(options.map((o) => o.userId));
        return [...options, ...ids.filter((id) => !seen.has(id) && known[id]).map((id) => known[id])];
    }, [options, ids, known]);

    return (
        <Space direction="vertical" className="w-full">
            <Select
                mode="multiple"
                labelInValue
                showSearch
                filterOption={false}
                className="w-full"
                placeholder="Gõ tên, email hoặc userId để tìm (để trống: hiện admin/CTV)"
                value={value}
                loading={fetching}
                onFocus={() => !options.length && search("")}
                onSearch={search}
                onChange={(vals) => onChange(vals.map((v) => Number(v.value)))}
                options={merged.map((u) => ({ value: u.userId, label: userLabel(u) }))}
                notFoundContent="Không tìm thấy tài khoản"
            />
            <Space.Compact>
                <Input style={{ width: 320 }} placeholder="Hoặc dán nhiều userId, cách nhau dấu phẩy" value={paste} onChange={(e) => setPaste(e.target.value)} onPressEnter={addPasted} />
                <Button onClick={addPasted}>Thêm</Button>
            </Space.Compact>
        </Space>
    );
}
